import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Shared';
import { Logo } from './ui/Logo';
import { Mail, Facebook, Twitter, Instagram, Youtube } from 'lucide-react';
import { useApply } from './ApplyContext';
export const TopNav = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const {
    open
  } = useApply();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <motion.nav className={`fixed top-0 left-0 right-0 z-50 transition-shadow duration-500 ${isScrolled ? 'shadow-md' : ''}`} data-id="element-248">
      {/* Top utility strip — navy */}
      <div className="bg-navy text-ivory" data-id="element-249">
        <div className="max-w-7xl mx-auto px-6 py-2 flex items-center justify-between" data-id="element-250">
          <a href="mailto:info@thesikhinitiative.org" className="flex items-center gap-2 text-xs sm:text-sm font-sans text-ivory/90 hover:text-kesari transition-colors" data-id="element-251">
            <Mail size={14} data-id="element-252" />
            <span className="hidden sm:inline" data-id="element-253">info@thesikhinitiative.org</span>
            <span className="sm:hidden" data-id="element-254">Contact</span>
          </a>
          <div className="flex items-center gap-4 text-ivory/80" data-id="element-255">
            <a href="#" aria-label="Facebook" className="hover:text-kesari transition-colors" data-id="element-256">
              <Facebook size={15} data-id="element-257" />
            </a>
            <a href="#" aria-label="Twitter" className="hover:text-kesari transition-colors" data-id="element-258">
              <Twitter size={15} data-id="element-259" />
            </a>
            <a href="#" aria-label="Instagram" className="hover:text-kesari transition-colors" data-id="element-260">
              <Instagram size={15} data-id="element-261" />
            </a>
            <a href="#" aria-label="YouTube" className="hover:text-kesari transition-colors" data-id="element-262">
              <Youtube size={15} data-id="element-263" />
            </a>
          </div>
        </div>
      </div>

      {/* Main nav — ivory with logo + links */}
      <div className={`bg-ivory/95 backdrop-blur-md border-b border-bronze/15 transition-all duration-500 ${isScrolled ? 'py-2' : 'py-3'}`} data-id="element-264">
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-265">
          <a href="#" className="flex items-center gap-3 group" data-id="element-266">
            <Logo height={56} className="group-hover:scale-[1.03] transition-transform duration-300" data-id="element-267" />
          </a>

          <div className="hidden md:flex items-center gap-8" data-id="element-268">
            <NavLinks data-id="element-269" />
          </div>

          <div className="flex items-center gap-4" data-id="element-270">
            <Button onClick={open} variant="solid" className="hidden sm:inline-flex py-2 px-5 text-sm" data-id="element-271">
              Apply Now
            </Button>
          </div>
        </div>
      </div>
    </motion.nav>;
};
const NavLinks = () => {
  const links = [{
    name: 'Program',
    href: '#program'
  }, {
    name: 'Why',
    href: '#why'
  }, {
    name: 'Outcomes',
    href: '#outcomes'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <>
      {links.map(link => <a key={link.name} href={link.href} className="relative text-sm font-sans text-navy/80 hover:text-kesari transition-colors group py-2" data-id="element-272">
          {link.name}
          <span className="absolute bottom-0 left-0 w-0 h-[1px] bg-kesari transition-all duration-300 group-hover:w-full" data-id="element-273" />
        </a>)}
    </>;
};